export let uploadProgress = 0;
export function toBase64WithProgress (file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onprogress = (event) => {
            if (event.lengthComputable) {
                uploadProgress = (event.loaded / event.total) * 50;
            }
        };
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.onerror = error => {
            reject(error);
        };
        reader.readAsDataURL(file);
    });
}